import axios from "axios";
import config from "../../config";
import { headers_get } from "../../main_components/tokens/get_headers_user";

const BASE_URL_BP = `${config?.URL_CONFIGURATION}`;
const BASE_URL_CONFIG = `${config?.URL_CONFIGURATION}`;

// Función auxiliar para manejar solicitudes HTTP
const request = async (method, baseUrl, endpoint, data = null) => {
  const url = `${baseUrl}${endpoint}`;
  try {
    const headers = await headers_get();
    return await axios({ method, url, data, headers });
  } catch (error) {
    console.error(`Error in ${method.toUpperCase()} ${url}:`, error?.response?.data || error.message);
    throw error;
  }
};

// 🔹 Gestión de Roles
export const get_roles = async () => request("get", BASE_URL_BP, "/test/modules");
export const post_roles = async (data) => request("post", BASE_URL_BP, "/test/modules", data);
export const update_roles = async (data, id) => request("put", BASE_URL_BP, `/test/modules/${id}`, data);
export const delete_roles = async (id) => request("delete", BASE_URL_BP, `/test/modules/${id}`);

// 🔹 Gestión de Subroles
export const post_sub_roles = async (data, id) => request("post", BASE_URL_BP, `/test/modules/${id}/submodules`, data);
export const update_sub_roles = async (data, id, sub_id) => request("put", BASE_URL_BP, `/test/modules/${id}/submodules/${sub_id}`, data);
export const delete_sub_roles = async (id, sub_id) => request("delete", BASE_URL_BP, `/test/modules/${id}/submodules/${sub_id}`);

// 🔹 Acciones Especiales en Módulos
export const post_special_modul = async (data, id, sub_id) => request("post", BASE_URL_BP, `/test/modules/${id}/submodules/${sub_id}/special-action`, data);
export const update_special_modul = async (data, id, sub_id, special_id) => request("put", BASE_URL_BP, `/test/modules/${id}/submodules/${sub_id}/special-action/${special_id}`, data);
export const delete_special_modul = async (id, sub_id, special_id) => request("delete", BASE_URL_BP, `/test/modules/${id}/submodules/${sub_id}/special-action/${special_id}`);

// 🔹 Gestión de Roles de Usuarios
export const get_roles_users = async (user) => request("get", BASE_URL_BP, `/test/users/${user}/roles`);
export const get_roles_users_available = async (user) => request("get", BASE_URL_CONFIG, `/test/users/${user}/roles/available`);

export const roles_users_get = async (user) => request("get", BASE_URL_CONFIG, `/od/users/${user}`);
export const roles_users_available_get = async (user) => request("get", BASE_URL_CONFIG, `/od/users/${user}/available-roles`);
export const post_rol_user = async (data, id) => request("put", BASE_URL_CONFIG, `/od/users/${id}`, data);


export const user_post = async (data) => request("post", BASE_URL_CONFIG, `/od/users`, data);
export const user_put = async (data, id) => request("put", BASE_URL_CONFIG, `/od/users/${id}`, data);
export const user_delete = async (id) => request("delete", BASE_URL_CONFIG, `/od/users/${id}`);



